export {
  FeatureCarFinance as default,
  getStaticProps,
} from '@cinch-nx/feature-car-finance'
